/** Document file template available types */
export enum DocumentFileTemplateTypeEnum {
  /** Deal */
  DEAL = 'DEAL',
}
